import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { Appointment } from './Appointment.entity';
import { Calculation } from './Calculation.entity';
import { CallMemo } from './CallMemo.entity';
import { CheckList } from './CheckList.entity';
import { Contract } from './Contract.entity';
import { Customer } from './Customer.entity';
import { DeliveryNote } from './DeliveryNote.entity';
import { Demand } from './Demand.entity';
import { Document } from './Document.entity';
import { EMail } from './EMail.entity';
import { InboundDeliveryNote } from './InboundDeliveryNote.entity';
import { InboundInvoice } from './InboundInvoice.entity';
import { Invoice } from './Invoice.entity';
import { Letter } from './Letter.entity';
import { Note } from './Note.entity';
import { Offer } from './Offer.entity';
import { Order } from './Order.entity';
import { ProductionContract } from './ProductionContract.entity';
import { Project } from './Project.entity';
import { Supplier } from './Supplier.entity';
import { Task } from './Task.entity';
import { Ticket } from './Ticket.entity';
import { TravelExpenses } from './TravelExpenses.entity';
import { VisitationReport } from './VisitationReport.entity';

export type WidgetDataUnion<T extends EMode = EMode.entity> =
  T extends EMode.entity
    ?
        | Customer<T>
        | Supplier<T>
        | Project<T>
        | Letter<T>
        | Task<T>
        | Ticket<T>
        | EMail<T>
        | Appointment<T>
        | CallMemo<T>
        | Note<T>
        | CheckList<T>
        | VisitationReport<T>
        | Document<T>
        | TravelExpenses<T>
        | Offer<T>
        | Contract<T>
        | Invoice<T>
        | DeliveryNote<T>
        | InboundDeliveryNote<T>
        | Calculation<T>
        | ProductionContract<T>
        | Demand<T>
        | Order<T>
        | InboundInvoice<T>
    : {
        /** Alias: Kunde */
        customer?: Customer<T>;
        /** Alias: Lieferant */
        supplier?: Supplier<T>;
        /** Alias: Projekt */
        project?: Project<T>;
        /** Alias: Brief */
        letter?: Letter<T>;
        /** Alias: Aufgabe */
        task?: Task<T>;
        /** Alias: Ticket */
        ticket?: Ticket<T>;
        /** Alias: EMail */
        eMail?: EMail<T>;
        /** Alias: Termin */
        appointment?: Appointment<T>;
        /** Alias: Telefonat */
        callMemo?: CallMemo<T>;
        /** Alias: Notiz */
        note?: Note<T>;
        /** Alias: Checkliste */
        checkList?: CheckList<T>;
        /** Alias: Besuchsbericht */
        visitationReport?: VisitationReport<T>;
        /** Alias: Dokument */
        document?: Document<T>;
        /** Alias: Reisekostenabrechnung */
        travelExpenses?: TravelExpenses<T>;
        /** Alias: Angebot */
        offer?: Offer<T>;
        /** Alias: Auftrag */
        contract?: Contract<T>;
        /** Alias: Rechnung */
        invoice?: Invoice<T>;
        /** Alias: Lieferschein */
        deliveryNote?: DeliveryNote<T>;
        /** Alias: Eingangslieferschein */
        inboundDeliveryNote?: InboundDeliveryNote<T>;
        /** Alias: Kalkulation */
        calculation?: Calculation<T>;
        /** Alias: Produktionsauftrag */
        productionContract?: ProductionContract<T>;
        /** Alias: Bedarfsanforderung */
        demand?: Demand<T>;
        /** Alias: Bestellung */
        order?: Order<T>;
        /** Alias: Eingangsrechnung */
        inboundInvoice?: InboundInvoice<T>;
      };

const fields: FieldDefinitions<WidgetDataUnion<EMode.query>> = {
  customer: {
    alias: 'customer',
    entity: Entities.customer,
  },
  supplier: {
    alias: 'supplier',
    entity: Entities.supplier,
  },
  project: {
    alias: 'project',
    entity: Entities.project,
  },
  letter: {
    alias: 'letter',
    entity: Entities.letter,
  },
  task: {
    alias: 'task',
    entity: Entities.task,
  },
  ticket: {
    alias: 'ticket',
    entity: Entities.ticket,
  },
  eMail: {
    alias: 'eMail',
    entity: Entities.eMail,
  },
  appointment: {
    alias: 'appointment',
    entity: Entities.appointment,
  },
  callMemo: {
    alias: 'callMemo',
    entity: Entities.callMemo,
  },
  note: {
    alias: 'note',
    entity: Entities.note,
  },
  checkList: {
    alias: 'checkList',
    entity: Entities.checkList,
  },
  visitationReport: {
    alias: 'visitationReport',
    entity: Entities.visitationReport,
  },
  document: {
    alias: 'document',
    entity: Entities.document,
  },
  travelExpenses: {
    alias: 'travelExpenses',
    entity: Entities.travelExpenses,
  },
  offer: {
    alias: 'offer',
    entity: Entities.offer,
  },
  contract: {
    alias: 'contract',
    entity: Entities.contract,
  },
  invoice: {
    alias: 'invoice',
    entity: Entities.invoice,
  },
  deliveryNote: {
    alias: 'deliveryNote',
    entity: Entities.deliveryNote,
  },
  inboundDeliveryNote: {
    alias: 'inboundDeliveryNote',
    entity: Entities.inboundDeliveryNote,
  },
  calculation: {
    alias: 'calculation',
    entity: Entities.calculation,
  },
  productionContract: {
    alias: 'productionContract',
    entity: Entities.productionContract,
  },
  demand: {
    alias: 'demand',
    entity: Entities.demand,
  },
  order: {
    alias: 'order',
    entity: Entities.order,
  },
  inboundInvoice: {
    alias: 'inboundInvoice',
    entity: Entities.inboundInvoice,
  },
};

export const widgetDataUnionEntityDefinition: EntitiyDefinition<
  WidgetDataUnion<EMode.query>
> = {
  kind: 'union',
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'WidgetDataUnion',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
